/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "./src/styles/global.css"

import smoothscroll from "smoothscroll-polyfill"

export const onClientEntry = () => {
  smoothscroll.polyfill()
}
